<template>
    <v-app-bar
            app
            color="primary"
            dark
            clipped-left
    >
        <v-app-bar-nav-icon @click="drawer()"></v-app-bar-nav-icon>

        <v-toolbar-title v-if="!$vuetify.breakpoint.xs">{{title}}</v-toolbar-title>

        <v-spacer></v-spacer>

        <router-view name="appBarAction"></router-view>
    </v-app-bar>
</template>

<script>
    import {BUS} from "~/plugins/bus";

    export default {
        name: "MainAppBar",

        data: () => ({
            title: 'Anglomir PRO'
        }),

        created() {
            BUS.$on('changeTitle', (title) => {
                this.title = title
            })
        },

        methods: {
            drawer() {
                BUS.$emit('drawer')
            }
        }
    }
</script>

<style scoped>

</style>